<template>
  <app-card radius-always class="group-item my-1" :to="{ name: $routes.GROUPS, params: { groupId: group.key } }">
    <v-img v-if="group.imageUrl" :src="group.imageUrl" cover :aria-label="$translate('common.ariaGroupImage')" class="group-image" />
    <div class="d-flex align-center justify-center pt-1 px-3">
      <div class="group-name font-size-title-small">{{ group.name }}</div>
    </div>
  </app-card>
</template>

<script>
export default {
  props: {
    group: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.group-item {
  min-width: 150px;
  max-width: 150px;
  height: 133px;

  .group-image {
    width: 150px;
    height: 100px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }

  .group-name {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
